define('NetSuite.SuiteCommCPQ.Main.Configuration', [
        'SC.Configuration'
    ],
    function MainConfiguration(Configuration) {
        'use strict';
        var isDebugMode = Configuration.SuiteCommCPQ.isDebugMode,
            options = {};
        options.pageGen = undefined;
        var Main_Configuration = {
            isConfigEnabled: function isConfigEnabled() {
                return Configuration.SuiteCommCPQ.isConfigEnabled;
            },
            isDebugMode: function isDebugMode() {
                return Configuration.SuiteCommCPQ.isDebugMode;
            },
            isAllConfigurable: function isAllConfgurable() {
                return Configuration.SuiteCommCPQ.allConfigurable;
            },
            isMatrixSelRequired: function isMatrixSelRequired() {
                return Configuration.SuiteCommCPQ.matrixSelRequired;
            },
            isAddConfigurableGen: function isAddConfigurableGen() {
                return Configuration.SuiteCommCPQ.addConfigurableGen;
            },
            isAddConfigurableLinked: function isAddConfigurableLinked() {
                return Configuration.SuiteCommCPQ.addConfigurableLinked;
            },
            get: function (option) {
                if (option)
                    return Configuration.SuiteCommCPQ[option];
                return Configuration.SuiteCommCPQ;
            },
            set: function(option, value) {
                if (option && value !== undefined) {
                    options[option] = value;
                }
            },
            isBrowser: function() {
                return options.pageGen === false;
            },
            _init: function() {
                if (this.isBrowser() && isDebugMode) {
                    window.vcpq = window.vcpq || {};
                    window.vcpq.sc_config = Configuration;
                    window.vcpq.sc_options = options;
                    window.vcpq.main_config = this;
                }
            }
        };
        return Main_Configuration;
    }
);
